import InstallPWA from './InstallPWA';

export default InstallPWA;
